import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import Sidebar from "../Sections/blog/Sidebar";
import Faq from "../Sections/home/Faq";
import Logos from "../Sections/home/Logos";
import { Link, useParams } from "react-router-dom";
import { Post, useGetAllBlogsQuery } from "../Redux/Apis/blogApi";
import Loading from "../Layouts/Loading";
import { fa_date } from "../utils/Persian";
import { useEffect, useState } from "react";
import MetaTags from "../Components/MetaTags";

function Blog() {
    let {catId} = useParams();
    let categoryID = 0;
    if (catId !== undefined) categoryID = parseInt(catId)

    const {data, isLoading, isSuccess } = useGetAllBlogsQuery()
    const [posts ,setPosts] = useState<Post[]>()
    const [state, setState] = useState({
        cat : 0,
        search: "",
    })

    const onSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault()
        if(state.search !== "") {
            setPosts(data?.posts.filter(item => item.title.toLowerCase().indexOf(state.search) > -1 || (item.body && item.body.toLowerCase().indexOf(state.search) > -1)))
            setState((prev) => ({ ...prev, search: "" }))
        }
        if(state.cat !== 0) {
            setPosts(data?.posts.filter(item => item.cat_id === state.cat))
            setState((prev) => ({ ...prev, cat: 0 }))
        }
    }

    const setCat = (cat:number) => {
        setPosts(data?.posts.filter(item => item.cat_id === cat))
    }

    useEffect(() => {
        if(categoryID !== 0) setPosts(data?.posts.filter(item => item.cat_id === categoryID))
        else setPosts(data?.posts)
    }, [data, categoryID])

    return ( 
        <>
        <MetaTags
            siteName="سایت مرجع آزمون GRE"
            title="صفحه وبلاگ | سایت مرجع آزمون GRE"
            description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
            url="https://grehub.org/blog"
            image="https://grehub.org/GREhub_LOGO.jpg"
            ogType="website"
            twitterCard="summary_large_image"
        />
        <div className="container-fluid bg-danger py-2 bg-header" style={{marginBottom: "90px"}}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">آخرین اخبار و مقالات</h1>
                    <Link to="/" className="h5 text-white">خانه</Link>
                    <FontAwesomeIcon icon={faCircle} className="text-white px-2"/>
                    <Link to="/blog" className="h5 text-white">وبلاگ</Link>
                </div>
            </div>
        </div>

        <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-8">
                        {isLoading && <Loading />}
                        {isSuccess && data && posts && posts.length > 0 ? <div className="row g-5">
                            {posts.map((row,index) => 
                            <div key={index} className="col-md-6 wow slideInUp" data-wow-delay="0.1s">
                                <div className="blog-item bg-light rounded overflow-hidden">
                                    <div className="blog-img position-relative overflow-hidden" style={{maxHeight: "300px"}} >
                                        <img className="img-fluid" src={row.image} alt={row.title}/>
                                        <div className="position-absolute top-0 start-0 bg-danger text-white rounded-end mt-5 py-2 px-4">{row.BlogCategory.name}</div>
                                    </div>
                                    <div className="p-4">
                                        <div className="d-flex mb-3">
                                            <small className="me-3"><FontAwesomeIcon icon="user" className="text-danger me-2"/>مدیر سایت</small>
                                            <small><FontAwesomeIcon icon="calendar-alt" className="text-danger me-2"/>{fa_date(row.create_date)}</small>
                                        </div>
                                        <h4 className="mb-3">{row.title}</h4>
                                        <p>{row.excerpt}</p>
                                        <Link className="text-uppercase text-danger" to={`/post/${row.id}/${row.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`}>مشاهده کامل <FontAwesomeIcon icon="arrow-left"/></Link>
                                    </div>
                                </div>
                            </div>)}
                            
                            {/* <div className="col-12 wow slideInUp" data-wow-delay="0.1s">
                                <nav aria-label="Page navigation">
                                <ul className="pagination pagination-lg m-0">
                                    <li className="page-item disabled">
                                    <a className="page-link rounded-0" href="!#" aria-label="Previous">
                                        <span aria-hidden="true"><FontAwesomeIcon icon="arrow-right"/></span>
                                    </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="!#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="!#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="!#">3</a></li>
                                    <li className="page-item">
                                    <a className="page-link rounded-0" href="!#" aria-label="Next">
                                        <span aria-hidden="true"><FontAwesomeIcon icon="arrow-left"/></span>
                                    </a>
                                    </li>
                                </ul>
                                </nav>
                            </div> */}
                        </div> : <p>هیچ پستی یافت نشد!</p>}
                    </div>
        
                    <Sidebar setState={setState} onSubmit={onSubmit} categories={data?.categories} last_posts={data?.last_posts} setCat={setCat}/>
                    <Faq data={data?.faq}/>
                    <Logos />
                </div>
            </div>
        </div>
        </>
    );
}

export default Blog;